import React from 'react';
import { Button } from '../Button/Button';

export const OrderSearch = ({ searchQuery, onSearchChange, onClearSearch }) => {
  return (
    <div className="order-search mb-2">
      <div className="input-group input-group-sm">
        <div className="input-group-prepend">
          <span className="input-group-text bg-white border-right-0">
            <i className="bx bx-search text-muted" />
          </span>
        </div>
        <input
          type="text"
          className="form-control border-left-0"
          placeholder={__('orders.map_search_placeholder')}
          value={searchQuery || ''}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        
        {searchQuery && (
          <div className="input-group-append">
            <Button onClick={onClearSearch} className="btn-xs btn-outline-danger order-map__button" icon="bx bx-x" />
          </div>
        )}
      </div>
    </div>
  );
};
